<template>
    <flex-element
        :element-type="elementType"
        :href="renderHref"
        :class="[htmlClass, stateClasses]"
        class="f-cursor-pointer"
        :target="target"
        :title="title"
        :rel="renderRel"
        tag="a"
        @click.native="onLinkClick"
    >
        {{ singleLineText }}
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-dumb';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'a-link',
    mixins: [baseAtom],

    props: {
        singleLineText: {
            type: String,
            default: '',
        },

        // "isActive" is used here instead of "isSelected" because "isSelected" is already being used as a prop in base-element
        // ... even though setting this to true adds the is-selected class
        isActive: {
            type: Boolean,
            default: false,
        },

        isDisabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isMatchingLink: false,
        };
    },

    computed: {
        stateClasses() {
            return {
                [STATE_CLASSES.MATCHING]: this.isMatchingLink,
                [STATE_CLASSES.SELECTED]: this.isActive,
            };
        },
    },

    watch: {
        isMatchingLink(isMatching) {
            this.$emit('match', isMatching);
        },
    },

    mounted() {
        this.checkActive();
    },

    methods: {
        checkActive() {
            if (this.href.includes('#')) {
                const currAnchor = window.location.hash.substring(1, window.location.hash.length);
                const splitHref = this.href.split('#');
                if (splitHref.length === 2 && currAnchor === splitHref[1]) {
                    this.isMatchingLink = true;
                }
            } else {
                // trim anchor and query
                const currentUrl = window.location.href.split('?')[0].split('#')[0];

                if (this.href.length && currentUrl.endsWith(this.href)) {
                    this.isMatchingLink = true;
                }
            }
        },

        onLinkClick(e) {
            if (this.isDisabled || !this.renderHref) e.preventDefault();
        },
    },
};
</script>
